import React from 'react';
const Main = ({ children }) => {
  return (
    <main className={`w-full h-dvh bg-lightMenu dark:bg-none dark:bg-darkMainColor overflow-auto `}>
      <div className="flex flex-col w-full h-[92%] px-2 ">{children}</div>
    </main>
  );
};

export default Main;
